import moment from 'moment'
import { mapQuoteToApiFormat, mapApiFormatToQuote, resetQuote } from '@/helpers'
import { coverPrice } from '@/helpers/quote-price'
// import { auth } from '~/services/firebase'

export const state = () => ({
  globalDiscount: {},
  price: {
    total: 0.0,
  },
  // The cover picked on the quick quote's price step: 'default' (Theft +
  // damage) or 'theft'. Saved to the quote by setCoverType, so quote setup
  // opens on it. `price` above stays the Theft + damage figure either way;
  // theftPrice ({ monthly, annual }) is the Theft only one, for when `price`
  // doesn't carry it.
  coverType: 'default',
  theftPrice: null,
  mtaPrice: {
    total: 0.0,
  },
  discountType: 'default',
  discountError: '',
  paymentError: '',
  paymentSuccess: null,
  quoteId: '',
  quote: {
    postcode: '',
    age: '',
    discount: null,
    discountCode: null,
    discountSlug: null,
    partnerSlug: null,
    partnerLabel: null,
    bicycles: [],
    effectiveDate: moment(),
    payment_type: 'annually',
    policy_type: '',
    insurance_components: {
      accessories_cover: 'none',
      amateur_racing: 'none',
      loss_of_earnings: 'none',
      personal_injury: 'none',
      public_liability: 'none',
      worldwide_cover: 'none',
    },
    userDetails: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      house: '',
      street: '',
      city: '',
      county: '',
      dateBirth: null,
    },
    hiplokProducts: {
      dx: {
        count: 0,
      },
      gold: {
        count: 0,
      },
      edx: {
        count: 0,
      },
    },
  },
  accessoriesData: [
    { id: '1', name: '250', price: '1.61', isBikeAddedPrice: '0.00' },
    { id: '2', name: '500', price: '3.23', isBikeAddedPrice: '1.61' },
    { id: '3', name: '1000', price: '4.84', isBikeAddedPrice: '3.23' },
    { id: '4', name: '1500', price: '6.45', isBikeAddedPrice: '4.84' },
  ],
  competitionData: [{ id: '1', Yes: '250', price: '5%' }],
  foreignTravelData: [
    { id: '1', name: '30 days', price: '5%' },
    { id: '2', name: '60 days', price: '10%' },
  ],
  isDiscountLoading: false,
  isPaymentLoading: false,
  isQuoteLoading: false,
  quoteError: '',
  isPriceLoading: false,
  priceError: '',
  isMtaPriceLoading: false,
  mtaPriceError: '',

  replacementValueSum: 0,
  isMta: false,
  mtaRules: [],
  isSendQuoteEmailLoading: false,
  sendQuoteEmailError: '',
  sendQuoteEmailSuccess: '',
  notifications: [],
  // The policy exactly as GET /api/policy/v1/policy/:code returned it, for the
  // dashboard policy page — mapApiFormatToQuote drops fields it needs (type,
  // payment_interval, photo file types).
  policyRaw: null,
})

export const getters = {
  quote(state) {
    return state.quote
  },
  discount(state) {
    return state.quote.discount
  },
  fakeDiscountVisualOnly(state) {
    const fakeDiscount = 10
    return parseInt(state.quote.discount, 10) + parseInt(fakeDiscount, 10)
  },
  isDiscountLoading(state) {
    return state.isDiscountLoading
  },
  isPaymentLoading(state) {
    return state.isPaymentLoading
  },
  discountType(state) {
    return state.discountType
  },
  discountSlug(state) {
    return state.quote.discountSlug
  },
  partnerLabel(state) {
    return state.quote.partnerLabel
  },
  discountError(state) {
    return state.discountError
  },
  paymentSuccess(state) {
    return state.paymentSuccess
  },
  paymentError(state) {
    return state.paymentError
  },
  quoteId(state) {
    return state.quote.id
  },
  price(state) {
    return state.price
  },
  coverType(state) {
    return state.coverType
  },
  // { monthly, annual } of Theft + damage, or null before it's priced.
  defaultPrice(state) {
    return coverPrice(state.price, 'default')
  },
  // { monthly, annual } of the cover picked on the price step, or null.
  chosenPrice(state) {
    if (state.coverType === 'theft') {
      return coverPrice(state.price, 'theft') || state.theftPrice
    }
    return coverPrice(state.price, 'default')
  },
  isPriceLoading(state) {
    return state.isPriceLoading
  },
  priceError(state) {
    return state.priceError
  },
  mtaPrice(state) {
    return state.mtaPrice
  },
  isMtaPriceLoading(state) {
    return state.isMtaPriceLoading
  },
  mtaPriceError(state) {
    return state.mtaPriceError
  },
  // bicycles
  bicycles(state) {
    return state.quote.bicycles
  },
  firstBikeValue(state) {
    if (state.quote.bicycles.length) {
      return state.quote.bicycles[0].value
    } else {
      return ''
    }
  },
  firstBikeMake(state) {
    return state.quote.bicycles.length ? state.quote.bicycles[0].make : ''
  },
  firstBike(state) {
    return state.quote.bicycles[0]
  },
  age(state) {
    return state.quote.age
  },
  postcode(state) {
    return state.quote.postcode
  },
  accessoriesData(state) {
    return state.accessoriesData
  },
  addedAccessories(state) {
    return state.quote.insurance_components.accessories_cover
  },
  competitionData(state) {
    return state.competitionData
  },
  addedCompetition(state) {
    return state.quote.insurance_components.amateur_racing
  },
  foreignTravelData(state) {
    return state.foreignTravelData
  },
  addedForeignTravel(state) {
    return state.quote.insurance_components.worldwide_cover
  },
  addedOffer(state) {
    return state.quote.hiplok
  },
  addedHiplok(state) {
    return state.quote.hiplokProducts
  },
  addedHiplokTotal(state) {
    return (
      state.quote.hiplokProducts.dx.count +
      state.quote.hiplokProducts.gold.count +
      state.quote.hiplokProducts.edx.count
    )
  },
  addedHiplokTotalPrice(state) {
    return (
      state.quote.hiplokProducts.dx.count * 30 +
      state.quote.hiplokProducts.gold.count * 45 +
      state.quote.hiplokProducts.edx.count * 50
    )
  },
  addedPersonalCover(state) {
    return state.quote.insurance_components.personal_injury
  },
  addedLossOfEarnings(state) {
    return state.quote.insurance_components.loss_of_earnings
  },
  addedPublicLiability(state) {
    return state.quote.insurance_components.public_liability
  },
  addedUserDetails(state) {
    return {
      ...state.quote.userDetails,
      postcode: state.quote.postcode,
    }
  },
  quoteEffectiveDate(state) {
    return state.quote.effectiveDate
  },
  quotePeriod(state) {
    return state.quote.period
  },
  isQuoteLoading(state) {
    return state.isQuoteLoading
  },
  quoteError(state) {
    return state.quoteError
  },
  // Bike photo
  replacementValueSum(state) {
    /* eslint-disable */
    return state.quote.bicycles.length > 0
      ? state.quote.bicycles
        .map((bicycle) => bicycle.value)
        .reduce(
          (accumulator, currentValue) =>
            Number(accumulator) + Number(currentValue)
        )
      : 0
    /* eslint-enable */
  },
  isMta(state) {
    return state.isMta
  },
  sendQuoteEmailError(state) {
    return state.sendQuoteEmailError
  },
  isSendQuoteEmailLoading(state) {
    return state.isSendQuoteEmailLoading
  },
  sendQuoteEmailSuccess(state) {
    return state.sendQuoteEmailSuccess
  },
  policyRaw(state) {
    return state.policyRaw
  },
  notifications(state) {
    return state.notifications
  },
  policyType(state) {
    switch (state.quote.payment_type) {
      case 1:
        return 'Stripe'
      case 2:
        return 'Premfina'
      case 12:
        return 'GoCardless'
      default:
        return ''
    }
  },
  allowMTA(state) {
    return state.quote.status === 1
  },
  isQuoteEmpty(state) {
    return !(
      state.quote.postcode !== '' ||
      state.quote.bicycles.length !== 0 ||
      state.quote.insurance_components.accessories_cover !== 'none' ||
      state.quote.insurance_components.amateur_racing !== 'none' ||
      state.quote.insurance_components.loss_of_earnings !== 'none' ||
      state.quote.insurance_components.personal_injury !== 'none' ||
      state.quote.insurance_components.public_liability !== 'none' ||
      state.quote.insurance_components.worldwide_cover !== 'none'
    )
  },
  allowFreeLockPromotion(state, getters) {
    const isBikeInRange =
      state.quote.bicycles.length !== 0
        ? state.quote.bicycles[0].value >= '1500'
        : false
    const isPartnerDiscountApplied = state.quote.discountSlug !== null
    const isPartnerWithPromotion = state.globalDiscount.hasPromotion
    const isFreeLockPromotionAllowed =
      isBikeInRange && (!isPartnerDiscountApplied || isPartnerWithPromotion)

    // console.log('isBikeInRange', isBikeInRange)
    // console.log('isPartnerDiscountApplied', isPartnerDiscountApplied)
    // console.log('isPartnerWithPromotion', state.globalDiscount.hasPromotion)
    // console.log('isFreeLockPromotionAllowed', isFreeLockPromotionAllowed)

    return isFreeLockPromotionAllowed
  },
}

export const mutations = {
  SET_DISCOUNT_TYPE: (state, payload) => {
    state.discountType = payload
  },
  SET_DISCOUNT: (state, payload) => {
    state.quote.discount = payload
  },
  SET_DISCOUNT_CODE: (state, payload) => {
    state.quote.discountCode = payload
  },
  SET_DISCOUNT_SLUG: (state, payload) => {
    state.quote.discountSlug = payload
  },
  SET_PARTNER_LABEL: (state, payload) => {
    state.quote.partnerLabel = payload
  },
  // TODO new discount. have to refactor all other discounts. BE need to unify all discount objects
  SET_GLOBAL_DISCOUNT: (state, payload) => {
    state.globalDiscount = payload
  },
  SET_DISCOUNT_LOADING: (state, payload) => {
    state.isDiscountLoading = payload
  },
  SET_DISCOUNT_ERROR: (state, payload) => {
    state.discountError = payload
  },
  SET_PAYMENT_LOADING: (state, payload) => {
    state.isPaymentLoading = payload
  },
  SET_PAYMENT_ERROR: (state, payload) => {
    state.paymentError = payload
  },
  SET_PAYMENT_SUCCESS: (state, payload) => {
    state.paymentSuccess = payload
  },
  // `total` (the annual figure) is what the older steps and GTM read, so a
  // quote price, which has none, gets one.
  UPDATE_PRICE: (state, price) => {
    const next = Object.assign({}, price)
    if (!Number(next.total)) {
      const own = coverPrice(next)
      if (own) next.total = own.annual
    }
    state.price = next
  },
  UPDATE_PRICE_LOADING: (state, payload) => {
    state.isPriceLoading = payload
  },
  UPDATE_PRICE_ERROR: (state, payload) => {
    state.priceError = payload
  },
  UPDATE_MTA_PRICE: (state, price) => {
    state.mtaPrice = Object.assign({}, price)
  },
  UPDATE_MTA_PRICE_LOADING: (state, payload) => {
    state.isMtaPriceLoading = payload
  },
  UPDATE_MTA_PRICE_ERROR: (state, payload) => {
    state.mtaPrice = payload
  },
  ADD_BIKE: (state, bike) => {
    state.quote.bicycles.push({
      make: bike.make,
      model: bike.model || '',
      value: bike.value,
      isEbike: bike.isEbike,
      id: 'tmp_' + Math.random().toString(36).substr(2, 9),
    })
    // Sorting bicycles based on its value
    state.quote.bicycles.sort((a, b) => {
      return b.value - a.value
    })
  },
  DELETE_BIKE: (state, bikeId) => {
    const bicycles = state.quote.bicycles
      .filter((bike) => bike.id !== bikeId)
      .sort((a, b) => {
        return b.value - a.value
      })
    state.quote.bicycles = bicycles
  },
  EDIT_BIKE: (state, _bike) => {
    const bike = state.quote.bicycles.find((b) => b.id === _bike.id)
    Object.assign(bike, _bike)
    // Sorting bicycles based on its value
    state.quote.bicycles.sort((a, b) => {
      return b.value - a.value
    })
  },
  EDIT_FIRST_BIKE_VALUE: (state, value) => {
    if (state.quote.bicycles.length !== 0) {
      state.quote.bicycles[0].value = value
    } else {
      state.quote.bicycles.push({
        make: 'default',
        value,
        id: 'tmp_' + Math.random().toString(36).substr(2, 9),
      })
    }
  },
  EDIT_FIRST_BIKE_MAKE: (state, make) => {
    if (state.quote.bicycles.length !== 0) {
      state.quote.bicycles[0].make = make
    } else {
      state.quote.bicycles.push({
        make,
      })
    }
  },
  EDIT_FIRST_BIKE_MODEL: (state, model) => {
    if (state.quote.bicycles.length !== 0) {
      state.quote.bicycles[0].model = model
    } else {
      state.quote.bicycles.push({
        model,
      })
    }
  },
  EDIT_FIRST_BIKE_IS_EBIKE: (state, isEbike) => {
    if (state.quote.bicycles.length !== 0) {
      state.quote.bicycles[0].isEbike = isEbike
    }
  },
  EDIT_AGE: (state, age) => {
    state.quote.age = age
  },
  EDIT_POSTCODE: (state, postcode) => {
    state.quote.postcode = postcode
  },
  SET_ACCESSORIES: (state, payload) => {
    state.quote.insurance_components.accessories_cover = payload
  },
  REMOVE_ACCESSORIES: (state, payload) => {
    state.quote.insurance_components.accessories_cover = 'none'
  },
  SET_COMPETITION: (state, payload) => {
    state.quote.insurance_components.amateur_racing = payload
  },
  REMOVE_COMPETITION: (state, payload) => {
    state.quote.insurance_components.amateur_racing = 'none'
  },
  SET_FOREIGN_TRAVEL: (state, payload) => {
    state.quote.insurance_components.worldwide_cover = payload
  },
  SET_OFFER: (state, payload) => {
    state.quote.hiplok = payload
  },
  SET_HIPLOK: (state, payload) => {
    state.quote.hiplokProducts = payload
  },
  REMOVE_FOREIGN_TRAVEL: (state, payload) => {
    state.quote.insurance_components.worldwide_cover = 'none'
  },
  SET_PERSONAL_COVER: (state, payload) => {
    state.quote.insurance_components.personal_injury = payload
  },
  REMOVE_PERSONAL_COVER: (state, payload) => {
    state.quote.insurance_components.personal_injury = 'none'
  },
  SET_LOSS_OF_EARNINGS: (state, payload) => {
    state.quote.insurance_components.loss_of_earnings = payload
  },
  REMOVE_LOSS_OF_EARNINGS: (state, payload) => {
    state.quote.insurance_components.loss_of_earnings = 'none'
  },
  SET_PUBLIC_LIABILITY: (state, payload) => {
    state.quote.insurance_components.public_liability = payload
  },
  REMOVE_PUBLIC_LIABILITY: (state, payload) => {
    state.quote.insurance_components.public_liability = 'none'
  },
  RESET_QUOTE: (state, quote) => {
    state.quote = Object.assign({}, quote)
  },
  SET_QUOTE: (state, quote) => {
    state.quote = Object.assign({}, quote)
  },
  SET_COVER_TYPE: (state, type) => {
    state.coverType = type
  },
  SET_THEFT_PRICE: (state, price) => {
    state.theftPrice = price || null
  },
  SET_QUOTE_ERROR: (state, payload) => {
    state.quoteError = payload
  },
  SET_QUOTE_LOADING: (state, payload) => {
    state.isQuoteLoading = payload
  },
  SET_USER_DETAILS: (state, payload) => {
    const { postcode, ...userDetails } = payload
    state.quote.userDetails = userDetails
    state.quote.postcode = postcode
  },
  SET_USER_DETAILS_HOUSE: (state, payload) => {
    state.quote.userDetails.house = payload
  },
  SET_USER_DETAILS_SREET: (state, payload) => {
    state.quote.userDetails.street = payload
  },
  SET_USER_DETAILS_CITY: (state, payload) => {
    state.quote.userDetails.city = payload
  },
  SET_USER_DETAILS_COUNTY: (state, payload) => {
    state.quote.userDetails.county = payload
  },
  SET_USER_DETAILS_DOB: (state, payload) => {
    state.quote.userDetails.dateBirth = payload
  },
  SET_USER_DETAILS_POSTCODE: (state, payload) => {
    state.quote.postcode = payload
  },

  SET_QUOTE_USER_DETAILS_EMAIL: (state, email) => {
    state.quote.userDetails.email = email
  },
  SET_QUOTE_USER_DETAILS_FIRST_NAME: (state, firstName) => {
    state.quote.userDetails.firstName = firstName
  },
  SET_QUOTE_USER_DETAILS_LAST_NAME: (state, lastName) => {
    state.quote.userDetails.lastName = lastName
  },
  SET_EFFECTIVE_DATE: (state, payload) => {
    state.quote.effectiveDate = payload
  },
  RESET_PRICE: (state) => {
    state.price = { total: 0.0 }
    state.mtaPrice = { total: 0.0 }
  },
  // Add serial number
  // Add bike photo
  SET_MTA_FLAG: (state, payload) => {
    state.isMta = payload
  },
  SET_REPLACEMENT_VALUE_SUM: (state, payload) => {
    state.quote.replacementValueSum = payload
  },
  SEND_QUOTE_EMAIL_SUCCESS: (state, payload) => {
    state.sendQuoteEmailSuccess = payload
  },
  SEND_QUOTE_EMAIL_ERROR: (state, payload) => {
    state.sendQuoteEmailError = payload
  },
  SEND_QUOTE_EMAIL_LOADING: (state, payload) => {
    state.isSendQuoteEmailLoading = payload
  },
  SET_POLICY_RAW: (state, payload) => {
    state.policyRaw = payload
  },
  SET_NOTIFICATION: (state, payload) => {
    const { notifications } = payload
    state.notifications = notifications
  },
}

// What the quote API said, or axios's own message when there was no response
// at all (network failure, request aborted).
function fetchErrorMessage(error) {
  return error?.response?.data?.error ?? error?.message ?? 'Request failed'
}

// A save with no quote id goes to `/quote/undefined` and the backend answers
// "Policy not found" (PEDALSURE-NUXT-FRONTEND-5RE) - usually because an
// earlier fetch failed and emptied the quote. Skip the save and leave a Sentry
// warning naming the page, so the cause is findable instead of the symptom.
function skipSyncWithoutId(store, action, commit) {
  commit('SET_QUOTE_LOADING', false)
  const page = store.app?.router?.currentRoute?.name
  console.warn(`${action} skipped: the quote has no id`)
  if (store.$sentry) {
    store.$sentry.withScope((scope) => {
      scope.setLevel('warning')
      scope.setTag('action', action)
      if (page) scope.setTag('page', page)
      store.$sentry.captureMessage(`${action} skipped: the quote has no id`)
    })
  }
}

export const actions = {
  // Discount
  setDiscount({ commit }, discount) {
    commit('SET_DISCOUNT', discount)
  },
  async getDefaultDiscount({ commit }) {
    try {
      const { data } = await this.$axios.get('/api/policy/v1/discount', {
        timeout: 10000,
      })
      // const res = await this.$axios.get('/api-admin/api/discount')
      // console.log('data', res.data)
      const discount = data.discount
      commit('SET_DISCOUNT_TYPE', 'default')
      commit('SET_DISCOUNT', discount)
    } catch (error) {
      console.log('GET_DEFAULT_DISCOUNT error', error)
      commit('SET_DISCOUNT', 0)
    }
  },
  async getCodeDiscount({ dispatch, commit }, code) {
    commit('SET_DISCOUNT_LOADING', true)
    try {
      const { data } = await this.$axios.get(
        `/api/policy/v1/discount/code/${code}`,
        {
          timeout: 10000,
        }
      )
      const discount = data.discount
      commit('SET_DISCOUNT_TYPE', 'code')
      commit('SET_DISCOUNT', discount)
      commit('SET_DISCOUNT_CODE', code)
      commit('SET_DISCOUNT_LOADING', false)
      commit('SET_DISCOUNT_ERROR', '')
      await dispatch('calculatePrice')
    } catch (error) {
      console.log('getCodeDiscount error', error.response.data)
      commit('SET_DISCOUNT_TYPE', 'default')
      commit('SET_DISCOUNT_LOADING', false)
      commit('SET_DISCOUNT_ERROR', 'Invalid code')
      throw new Error(error)
    }
  },
  async getPartnerDiscount({ dispatch, commit, getters }, slug) {
    commit('SET_DISCOUNT_LOADING', true)
    try {
      const { data } = await this.$axios.get(
        `/api/policy/v1/discount/partner/${slug}`,
        {
          timeout: 10000,
        }
      )

      commit('SET_GLOBAL_DISCOUNT', data)

      const { discount, code, label } = data
      const text = label || slug

      commit('SET_DISCOUNT_TYPE', 'partner')
      commit('SET_DISCOUNT_CODE', code)
      commit('SET_DISCOUNT', discount)
      commit('SET_DISCOUNT_SLUG', slug)
      commit('SET_PARTNER_LABEL', text)
      commit('SET_DISCOUNT_LOADING', false)
      commit('SET_DISCOUNT_ERROR', '')
      if (!getters.isQuoteEmpty) {
        await dispatch('calculatePrice')
      }
    } catch (error) {
      console.log('getPartnerDiscount error', error.response.data)
      commit('SET_DISCOUNT_TYPE', 'default')
      commit('SET_DISCOUNT_LOADING', false)
      commit('SET_DISCOUNT_ERROR', 'Invalid code')
      throw new Error(error)
    }
  },
  // Fetching price
  async calculatePrice({ commit, state }) {
    commit('UPDATE_PRICE_LOADING', true)
    // let token = ''
    // if (auth.currentUser) {
    //   token = await auth.currentUser.getIdToken()
    // }

    try {
      // const price = await this.$axios.$post('/api/policy/v1/price', state.quote, { headers:
      //   { authorization: `Bearer ${token}` } })
      const price = await this.$axios.$post(
        '/api/policy/v1/price',
        state.quote,
        { timeout: 10000 }
      )
      commit('UPDATE_PRICE', price)
      commit('UPDATE_PRICE_LOADING', false)
      commit('UPDATE_PRICE_ERROR', '')
    } catch (error) {
      // console.log('CALCULATE_PRICE error', error)
      commit('UPDATE_PRICE', { total: 0.0 })
      commit('UPDATE_PRICE_LOADING', false)
      commit('UPDATE_PRICE_ERROR', error)
      // this.$sentry.captureException(new Error(error))
    }
  },
  // Fetching MTA price
  async calculateMtaPrice({ commit, state }) {
    commit('UPDATE_MTA_PRICE_LOADING', true)
    try {
      const price = await this.$axios.$post('/api/policy/v1/price', state.quote)
      console.log('price', price)
      // TODO @@@@@
      commit('UPDATE_MTA_PRICE', { total: 6666 })
      commit('UPDATE_MTA_PRICE_LOADING', false)
      commit('UPDATE_MTA_PRICE_ERROR', '')
    } catch (error) {
      console.log('CALCULATE_MTA_PRICE error', error)
      commit('UPDATE_MTA_PRICE', { total: 0.0 })
      commit('UPDATE_MTA_PRICE_LOADING', false)
      commit('UPDATE_MTA_PRICE_ERROR', error)
      // this.$sentry.captureException(new Error(error))
    }
  },
  // bicycles
  async addBike({ dispatch, commit }, bike) {
    commit('ADD_BIKE', bike)
    await dispatch('calculatePrice')
  },
  async deleteBike({ dispatch, commit }, bike) {
    commit('DELETE_BIKE', bike.id)
    await dispatch('calculatePrice')
  },
  async editBike({ dispatch, commit }, bike) {
    commit('EDIT_BIKE', bike)
    await dispatch('calculatePrice')
  },
  async editFirstBikeValue({ dispatch, commit }, value) {
    commit('EDIT_FIRST_BIKE_VALUE', value)
    await dispatch('calculatePrice')
  },
  async editFirstBikeMake({ dispatch, commit }, make) {
    commit('EDIT_FIRST_BIKE_MAKE', make)
    await dispatch('calculatePrice')
  },
  async editAge({ dispatch, commit }, age) {
    commit('EDIT_AGE', age)
    await dispatch('calculatePrice')
  },
  async editPostcode({ dispatch, commit }, postcode) {
    commit('EDIT_POSTCODE', postcode)
    await dispatch('calculatePrice')
  },
  editRiskFactors({ commit }, { bike, address, dateOfBirth }) {
    console.log('kor', bike)

    commit('EDIT_FIRST_BIKE_VALUE', bike.firstBikeValue)
    commit('EDIT_FIRST_BIKE_IS_EBIKE', bike.isEbike)
    commit('SET_USER_DETAILS_HOUSE', address.house)
    commit('SET_USER_DETAILS_SREET', address.street)
    commit('SET_USER_DETAILS_CITY', address.city)
    commit('SET_USER_DETAILS_COUNTY', address.county)
    commit('SET_USER_DETAILS_POSTCODE', address.postcode)
    const date = moment(
      `${dateOfBirth.day}-${dateOfBirth.month}-${dateOfBirth.year}`,
      'D/M/YYYY'
    ).format('YYYY-MM-DD')
    commit('SET_USER_DETAILS_DOB', date)

    // commit('EDIT_AGE', riskFactors.age)
    // commit('EDIT_POSTCODE', riskFactors.postcode)
    // No calculatePrice here: both callers create the quote straight after,
    // and createQuote takes the price from that response.
  },
  async editPersonalCoverRiskFactors({ dispatch, commit }, riskFactors) {
    commit('EDIT_AGE', riskFactors.age)
    commit('EDIT_POSTCODE', riskFactors.postcode)
    commit('SET_PERSONAL_COVER', 'bronze')
    await dispatch('calculatePrice')
  },
  // Policy features
  async setAccessories({ dispatch, commit }, acc) {
    commit('SET_ACCESSORIES', acc)
    await dispatch('calculatePrice')
  },
  async setCompetition({ dispatch, commit }, comp) {
    commit('SET_COMPETITION', comp)
    await dispatch('calculatePrice')
  },
  async setForeignTravel({ dispatch, commit }, travel) {
    commit('SET_FOREIGN_TRAVEL', travel)
    await dispatch('calculatePrice')
  },
  setOffer({ dispatch, commit }, offer) {
    console.log('tretretretete', offer)
    commit('SET_OFFER', offer)
  },
  setHiplok({ dispatch, commit }, hiplok) {
    commit('SET_HIPLOK', hiplok)
  },
  async setPersonalCover({ dispatch, commit, getters }, personalCover) {
    commit('SET_PERSONAL_COVER', personalCover)
    switch (personalCover) {
      case 'bronze':
        if (getters.addedLossOfEarnings > 200) {
          commit('SET_LOSS_OF_EARNINGS', 200)
        }
        commit('SET_PUBLIC_LIABILITY', 1)
        break
      case 'silver':
        if (getters.addedLossOfEarnings > 500) {
          commit('SET_LOSS_OF_EARNINGS', 500)
        }
        commit('SET_PUBLIC_LIABILITY', 1)
        break
      case 'gold':
        commit('SET_PUBLIC_LIABILITY', 1)
        break
      case 'none':
        commit('SET_LOSS_OF_EARNINGS', 'none')
        commit('SET_PUBLIC_LIABILITY', 'none')
        break
    }
    await dispatch('calculatePrice')
  },
  async setLossOfEarnings({ dispatch, commit }, LossOfEarnings) {
    commit('SET_LOSS_OF_EARNINGS', LossOfEarnings)
    await dispatch('calculatePrice')
  },
  async setPublicLiability({ dispatch, commit }, PublicLiability) {
    commit('SET_PUBLIC_LIABILITY', PublicLiability)
    await dispatch('calculatePrice')
  },
  async fetchQuote({ dispatch, commit }, id) {
    commit('SET_QUOTE_LOADING', true)
    try {
      const quote = await this.$axios.$get(`/api/policy/v1/quote/${id}`)
      // console.log('quote', quote)
      commit('SET_MTA_FLAG', false)
      commit('SET_QUOTE', mapApiFormatToQuote(quote))
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', '')
    } catch (error) {
      // No `response` on a network failure; reading through it threw a
      // second TypeError from inside this catch. The server route reports
      // backend failures to Sentry itself.
      const message = fetchErrorMessage(error)
      console.log('FRONTEND ++++ fetch quote error', message)
      commit('SET_QUOTE', resetQuote())
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', message)
      commit('RESET_PRICE')
    }
  },

  async fetchPublicQuote({ dispatch, commit }, id) {
    commit('SET_QUOTE_LOADING', true)
    console.log('id', id)
    try {
      const quote = await this.$axios.$get(`/api/policy/v1/quote/public/${id}`)
      commit('SET_MTA_FLAG', false)
      commit('SET_QUOTE', mapApiFormatToQuote(quote))
      if (coverPrice(quote && quote.price)) commit('UPDATE_PRICE', quote.price)
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', '')
    } catch (error) {
      commit('SET_QUOTE', resetQuote())
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', fetchErrorMessage(error))
      commit('RESET_PRICE')
    }
  },

  async fetchPolicy({ dispatch, commit }, id) {
    commit('SET_QUOTE_LOADING', true)
    try {
      const policy = await this.$axios.$get(`/api/policy/v1/policy/${id}`)

      commit('SET_MTA_FLAG', true)
      commit('SET_POLICY_RAW', policy)
      commit('SET_QUOTE', mapApiFormatToQuote(policy))
      commit('SET_NOTIFICATION', mapApiFormatToQuote(policy))
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', '')
    } catch (error) {
      // console.log('fetch policy error', error)
      commit('SET_POLICY_RAW', null)
      commit('SET_QUOTE', resetQuote())
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', error)
      commit('RESET_PRICE')
      // this.$sentry.captureException(new Error(error))
    }
  },
  async createQuote({ dispatch, commit, state }) {
    commit('SET_QUOTE_LOADING', true)
    try {
      console.log('createQuote state.quote', state.quote)
      const _quote = mapQuoteToApiFormat(state.quote)
      const quote = await this.$axios.$post('/api/policy/v1/quote', _quote)
      commit('SET_QUOTE', mapApiFormatToQuote(quote))
      // A new quote starts on the recommended cover.
      commit('SET_COVER_TYPE', 'default')
      commit('SET_THEFT_PRICE', null)
      // The create response is priced (price.default and price.theft), so it
      // stands in for a separate /price call.
      if (coverPrice(quote && quote.price)) {
        commit('UPDATE_PRICE', quote.price)
        commit('UPDATE_PRICE_ERROR', '')
      }
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', '')
      console.log('Quote created! ', quote)
    } catch (error) {
      console.log('create quote error: ', error)
      commit('SET_QUOTE', resetQuote())
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', error)
      commit('RESET_PRICE')
    }
  },
  async createPersonalCoverQuote({ dispatch, commit, state }) {
    commit('SET_QUOTE_LOADING', true)
    try {
      commit('SET_PERSONAL_COVER', 'bronze')
      const _quote = mapQuoteToApiFormat(state.quote)
      const quote = await this.$axios.$post('/api/policy/v1/quote', _quote)
      commit('SET_QUOTE', mapApiFormatToQuote(quote))
      // The create response is priced (price.default and price.theft), so it
      // stands in for a separate /price call.
      if (coverPrice(quote && quote.price)) {
        commit('UPDATE_PRICE', quote.price)
        commit('UPDATE_PRICE_ERROR', '')
      }
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', '')
      console.log('Quote created! ', quote)
    } catch (error) {
      console.log('create quote error: ', error)
      commit('SET_QUOTE', resetQuote())
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', error)
      commit('RESET_PRICE')
    }
  },
  // Saves the cover type on the quote, the same way quote setup does: the
  // theft quote endpoint takes the whole quote back with `type` set. Throws
  // on failure, so the caller decides what a failed save means.
  async setCoverType({ commit, state }, type) {
    const id = state.quote.id
    const quote = await this.$axios.$get(`/api/policy/v1/theft/quote/${id}`)
    const payload = { ...quote, type }
    delete payload.customer
    const saved = await this.$axios.$post(
      `/api/policy/v1/theft/quote/${id}`,
      payload
    )
    // A newer quote may have replaced this one while the calls were out.
    if (state.quote.id !== id) return
    commit('SET_COVER_TYPE', type)
    const theft = coverPrice(saved && saved.price, 'theft')
    if (theft) commit('SET_THEFT_PRICE', theft)
  },
  async syncQuote({ dispatch, commit, state, rootGetters }) {
    const email = rootGetters['user/userEmail']
    commit('SET_QUOTE_LOADING', true)
    try {
      // `type` carries the cover picked on the price step, so this sync
      // can't undo what setCoverType saved.
      const _quote = {
        ...mapQuoteToApiFormat(state.quote, email),
        type: state.coverType,
      }
      if (!_quote.id) return skipSyncWithoutId(this, 'syncQuote', commit)
      const quote = await this.$axios.$put(
        `/api/policy/v1/quote/${_quote.id}`,
        _quote
      )
      commit('SET_QUOTE', mapApiFormatToQuote(quote))
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', '')
    } catch (error) {
      console.log('update quote error: ', error)
      commit('SET_QUOTE', resetQuote())
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', error)
      commit('RESET_PRICE')
    }
  },
  async syncPublicQuote({ dispatch, commit, state, rootGetters }) {
    const email = rootGetters['user/userEmail']
    console.log('sync public quote')
    commit('SET_QUOTE_LOADING', true)
    try {
      // `type` carries the cover picked on the price step, so this sync
      // can't undo what setCoverType saved.
      const _quote = {
        ...mapQuoteToApiFormat(state.quote, email),
        type: state.coverType,
      }
      if (!_quote.id) return skipSyncWithoutId(this, 'syncPublicQuote', commit)
      const quote = await this.$axios.$put(
        `/api/policy/v1/quote/public/${_quote.id}`,
        _quote
      )
      commit('SET_QUOTE', mapApiFormatToQuote(quote))
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', '')
    } catch (error) {
      console.log('update quote error: ', error)
      commit('SET_QUOTE', resetQuote())
      commit('SET_QUOTE_LOADING', false)
      commit('SET_QUOTE_ERROR', error)
      commit('RESET_PRICE')
    }
  },
  resetQuote({ dispatch, commit, state }) {
    commit('RESET_QUOTE', resetQuote(state.quote))
  },
  setUserDetails({ dispatch, commit }, userDetails) {
    commit('SET_USER_DETAILS', userDetails)
  },
  setUserAddress({ dispatch, commit }, userAddress) {
    commit('SET_USER_ADDRESS', userAddress)
  },
  setQuoteUserDetailsEmail({ dispatch, commit }, email) {
    commit('SET_QUOTE_USER_DETAILS_EMAIL', email)
  },
  setEffectiveDate({ dispatch, commit }, date) {
    commit('SET_EFFECTIVE_DATE', date)
  },

  // All remove actions
  async removeAccessories({ dispatch, commit }) {
    commit('REMOVE_ACCESSORIES')
    await dispatch('calculatePrice')
  },
  async removeCompetition({ dispatch, commit }) {
    commit('REMOVE_COMPETITION')
    await dispatch('calculatePrice')
  },
  async removeForeignTravel({ dispatch, commit }) {
    commit('REMOVE_FOREIGN_TRAVEL')
    await dispatch('calculatePrice')
  },
  async removePersonalCover({ dispatch, commit }) {
    commit('REMOVE_PERSONAL_COVER')
    commit('REMOVE_LOSS_OF_EARNINGS')
    await dispatch('calculatePrice')
  },
  async removeLossOfEarnings({ dispatch, commit }) {
    commit('REMOVE_LOSS_OF_EARNINGS')
    await dispatch('calculatePrice')
  },
  async removePublicLiability({ dispatch, commit }) {
    commit('REMOVE_PUBLIC_LIABILITY')
    await dispatch('calculatePrice')
  },

  // PAYMENT
  // async makePaymentAnnual ({ state, commit }, { quoteId, cardDetails }) {
  //   commit('SET_PAYMENT_LOADING', true)
  //   try {
  //     const data = await this.$axios.$post(`/api/policy/v1/pay/${quoteId}/annually`, {
  //       card: cardDetails
  //     })
  //     this.$toast.success(`Success payment ${data.policy_code}`)
  //     this.$gtm.push({
  //       event: 'purchase_complete',
  //       'payment_type': 'annually',
  //       'transactionId': data.policy_code,
  //       'transactionTotal': data.payment_type_amount,
  //       'prices.total_discounted': data.payment_type_amount,
  //       'policy_total': data.payment_type_amount,
  //       'prices': {
  //         'discount_percent': data.discount_percent,
  //         'total_discounted': data.payment_type_amount
  //       }
  //     })
  //     const _data = { ...state.quote, url: process.env.baseDomainUrl, paymentMethod: 'Stripe' }
  //     this.$axios.$post('/api/notifications/v1/policy-purchased', _data)
  //     commit('SET_PAYMENT_LOADING', false)
  //     commit('SET_PAYMENT_SUCCESS', true)
  //     commit('SET_PAYMENT_ERROR', '')
  //     commit('RESET_QUOTE', resetQuote())
  //     commit('RESET_PRICE')
  //     this.$router.push({ path: `/dashboard`, query: { type: 'paid' } })
  //   } catch (error) {
  //     console.log('PAYMENT error', error.response.data.message.error)
  //     this.$toast.error(`Error payment ${error.response.data.message.error}`)
  //     commit('SET_PAYMENT_LOADING', false)
  //     commit('SET_PAYMENT_SUCCESS', false)
  //     commit('SET_PAYMENT_ERROR', error.response.data.message.error || 'Error')
  //   }
  // },
  // PREFINA
  async makePaymentMonthly({ state, commit }, { quoteId, premfinaDetails }) {
    commit('SET_PAYMENT_LOADING', true)
    try {
      const data = await this.$axios.$post(
        `/api/policy/v1/pay/${quoteId}/monthly`,
        premfinaDetails
      )
      this.$toast.success(`Success payment ${data.policy_code}`)
      this.$gtm.push({
        event: 'purchase_complete',
        payment_type: 'monthly',
        transactionId: data.policy_code,
        transactionTotal: data.payment_type_amount,
        'prices.total_discounted': data.payment_type_amount,
        policy_total: data.payment_type_amount,
        prices: {
          discount_percent: data.discount_percent,
          total_discounted: data.payment_type_amount,
        },
      })
      const _data = {
        ...state.quote,
        url: process.env.baseDomainUrl,
        paymentMethod: 'Premfina',
      }
      this.$axios.$post('/api/notifications/v1/policy-purchased', _data)

      commit('SET_PAYMENT_LOADING', false)
      commit('SET_PAYMENT_SUCCESS', true)
      commit('SET_PAYMENT_ERROR', '')
      commit('RESET_QUOTE', resetQuote())
      commit('RESET_PRICE')
      this.$router.push({ path: `/dashboard`, query: { type: 'paid' } })
    } catch (error) {
      console.log('PAYMENT error', error.response.data.message.error)
      this.$toast.error(`Error payment ${error.response.data.message.error}`)
      commit('SET_PAYMENT_LOADING', false)
      commit('SET_PAYMENT_SUCCESS', false)
      commit('SET_PAYMENT_ERROR', error.response.data.message.error)
    }
  },
  setMtaFlag({ dispatch, commit }, flag) {
    commit('SET_MTA_FLAG', flag)
  },

  // EMAIL
  async sendQuoteEmail({ dispatch, commit }, code) {
    commit('SEND_QUOTE_EMAIL_LOADING', true)
    try {
      const data = await this.$axios.$get(`/api/policy/v1/quote/${code}/email`)
      commit('SEND_QUOTE_EMAIL_LOADING', false)
      commit('SEND_QUOTE_EMAIL_SUCCESS', data.success)
      commit('SEND_QUOTE_EMAIL_ERROR', '')
    } catch (error) {
      console.log('SEND QUOTE EMAIL error', error.response.data.message.error)
      this.$toast.error(
        `Error sending email ${error.response.data.message.error}`
      )
      commit('SEND_QUOTE_EMAIL_LOADING', false)
      commit('SEND_QUOTE_EMAIL_SUCCESS', false)
      commit('SEND_QUOTE_EMAIL_ERROR', error.response.data.message.error)
    }
  },
}
